'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

var _background = require('redux/modules/background');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// default函数中会加上参数store 在判断哪个路由需要用户登录以及其他权限时使用

exports.default = function (store) {
  var changeBackGroundColorToBlack = function changeBackGroundColorToBlack() {
    store.dispatch((0, _background.changeToBlack)());
  };

  var changeBackGroundColorToWhite = function changeBackGroundColorToWhite() {
    store.dispatch((0, _background.changeToWhite)());
  };
  var requireLogin = function requireLogin(nextState, replace, cb) {
    function checkAuth() {
      var _store$getState = store.getState();

      var user = _store$getState.auth.user;

      if (!user) {
        // oops, not logged in, so can't be here!
        // changeBackGroundColorToWhite();
        replace('/login');
      }
      cb();
    }

    if (!(0, _auth.isLoaded)(store.getState())) {
      store.dispatch((0, _auth.load)()).then(checkAuth);
    } else {
      checkAuth();
    }
  };

  var requireLogin0831 = function requireLogin0831(nextState, replace, cb) {
    function checkAuth() {
      var _store$getState2 = store.getState();

      var user = _store$getState2.auth.user;

      if (!user) {
        // oops, not logged in, so can't be here!
        // changeBackGroundColorToWhite();
        replace('/login');
      }
      cb();
    }

    if (!(0, _auth.isLoaded)(store.getState())) {
      store.dispatch((0, _auth.load)()).then(checkAuth);
    } else {
      checkAuth();
    }
  };

  var changeBackGroundColorToBlackAndLogin = function changeBackGroundColorToBlackAndLogin(nextState, replace, cb) {
    store.dispatch((0, _background.changeToBlack)());
    requireLogin(nextState, replace, cb);
  };

  var changeBackGroundColorToWhiteAndLogin = function changeBackGroundColorToWhiteAndLogin(nextState, replace, cb) {
    store.dispatch((0, _background.changeToWhite)());
    requireLogin(nextState, replace, cb);
  };

  var isLogin = function isLogin(nextState, replace, cb) {
    function checkAuth() {
      var _store$getState3 = store.getState();

      var user = _store$getState3.auth.user;

      if (user) {
        // oops, not logged in, so can't be here!
        // changeBackGroundColorToBlack();
        replace('/personalcenter/personalbuying/productpreselection');
      }
      cb();
    }

    if (!(0, _auth.isLoaded)(store.getState())) {
      store.dispatch((0, _auth.load)()).then(checkAuth);
    } else {
      checkAuth();
    }
  };

  var isExperienceShopLogin = function isExperienceShopLogin(nextState, replace, cb) {
    function checkAuth() {
      var _store$getState4 = store.getState();

      var user = _store$getState4.auth.user;

      if (user) {
        // oops, not logged in, so can't be here!
        // changeBackGroundColorToBlack();
        replace('/personalcenter/experienceshop/experienceshopinfo');
      }
      cb();
    }

    if (!(0, _auth.isLoaded)(store.getState())) {
      store.dispatch((0, _auth.load)()).then(checkAuth);
    } else {
      checkAuth();
    }
  };

  var getAuthDataInfo = function getAuthDataInfo() {
    store.dispatch((0, _auth.load)());
  };

  return _react2.default.createElement(
    _reactRouter.Route,
    { onEnter: getAuthDataInfo },
    _react2.default.createElement(_reactRouter.Route, { path: '/experienceshopfirstpage', component: _containers.ExperienceShopFirstPage }),
    _react2.default.createElement(_reactRouter.Route, { path: '/workstation/:workstationId', component: _containers.Workstation }),
    _react2.default.createElement(_reactRouter.Route, { path: '/artinstitute', onEnter: requireLogin0831, component: _containers.ArtInstitute }),
    _react2.default.createElement(_reactRouter.Route, { path: '/characteristicregional', component: _containers.CharacteristicRegional }),
    _react2.default.createElement(_reactRouter.Route, { path: '/characteristicregionalstore', component: _containers.CharacteristicRegionalStore }),
    _react2.default.createElement(_reactRouter.Route, { path: '/dymd', component: _containers.DongYang }),
    _react2.default.createElement(_reactRouter.Route, { path: '/zzgwc', component: _containers.ZhenzhouGongMei }),
    _react2.default.createElement(_reactRouter.Route, { path: '/helpdoc', component: _containers.HelpDoc }),
    _react2.default.createElement(_reactRouter.Route, { path: '/vrproductpage/:productId', component: _containers.VrProductPage }),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _containers.DetailPage },
      _react2.default.createElement(_reactRouter.Route, { path: 'intro', component: _containers.Intro }),
      _react2.default.createElement(_reactRouter.Route, { path: '/productquickpreview/:productId', component: _containers.ProductDetailQuickPreview }),
      _react2.default.createElement(_reactRouter.Route, { path: '/product/:productId', component: _containers.ProductDetails }),
      _react2.default.createElement(_reactRouter.Route, { path: '/productpreview/:productId', component: _containers.ProductDetailsPreview }),
      _react2.default.createElement(_reactRouter.Route, { path: '/customproduct/:productId', component: _containers.CustomProductDetail }),
      _react2.default.createElement(_reactRouter.Route, { path: '/customproductpreview/:productId', component: _containers.CustomProductDetailPreview }),
      _react2.default.createElement(_reactRouter.Route, { path: '/shop/:shopId', component: _containers.ShopDetail }),
      _react2.default.createElement(_reactRouter.Route, { path: '/shoppreview/:shopId', component: _containers.ShopDetailPreview }),
      _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopdetail/:experienceShopId', component: _containers.ExperienceShopNewDetail }),
      _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopdetailpreview/:experienceShopId', component: _containers.ExperienceShopNewPreviewDetail }),
      _react2.default.createElement(_reactRouter.Route, { path: 'service/:type/:serviceId', component: _containers.ServiceDetail }),
      _react2.default.createElement(_reactRouter.Route, { path: 'servicePreview/:type/:serviceId', component: _containers.ServiceDetailPreview }),
      _react2.default.createElement(_reactRouter.Route, { path: '/designer/:designerId', component: _containers.DesignerDetail }),
      _react2.default.createElement(_reactRouter.Route, { path: '/designerpreview/:designerId', component: _containers.DesignerDetailPreview })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: '/', component: _containers.App },
      _react2.default.createElement(_reactRouter.Route, { path: 'clear', component: _containers.ClearSession }),
      _react2.default.createElement(
        _reactRouter.Route,
        { onEnter: changeBackGroundColorToBlack },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Main })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { onEnter: changeBackGroundColorToBlackAndLogin },
        _react2.default.createElement(
          _reactRouter.Route,
          { onEnter: requireLogin },
          _react2.default.createElement(_reactRouter.Route, { path: 'orderlist', component: _containers.OrderList }),
          _react2.default.createElement(_reactRouter.Route, { path: 'orderdetail/:orderId', component: _containers.OrderDetail }),
          _react2.default.createElement(_reactRouter.Route, { path: 'serviceorderlist', component: _containers.ServiceOrderList }),
          _react2.default.createElement(_reactRouter.Route, { path: 'serviceorderacceptance/:serviceOrderId', component: _containers.ServiceOrderAcceptance }),
          _react2.default.createElement(_reactRouter.Route, { path: 'serviceorderconfirm/:serviceOrderId', component: _containers.ServiceOrderConfirm }),
          _react2.default.createElement(_reactRouter.Route, { path: 'orderevaluate/:orderId', component: _containers.OrderEvaluate }),
          _react2.default.createElement(_reactRouter.Route, { path: 'servicebuyevaluate/:orderId', component: _containers.ServiceOrderEvaluate })
        ),
        _react2.default.createElement(_reactRouter.Route, { path: 'groupbuyingorderlist', component: _containers.GroupBuyingOrderList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'groupbuyingorderdetail/:orderId', component: _containers.GroupBuyingOrderDetail })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { onEnter: changeBackGroundColorToWhite },
        _react2.default.createElement(_reactRouter.Route, { path: 'home', component: _containers.Home }),
        _react2.default.createElement(_reactRouter.Route, { path: 'customproductslist', component: _containers.CustomProductList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'experienceshoplogin', onEnter: isExperienceShopLogin, component: _containers.ExperienceShopLogin }),
        _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopregisternew', component: _containers.ExperienceShopRegisterNew }),
        _react2.default.createElement(_reactRouter.Route, { path: 'bvlogin', component: _containers.BVLogin }),
        _react2.default.createElement(_reactRouter.Route, { path: 'shoplogin', component: _containers.ShopLogin }),
        _react2.default.createElement(
          _reactRouter.Route,
          { onEnter: isLogin },
          _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _containers.Login }),
          _react2.default.createElement(_reactRouter.Route, { path: 'register', component: _containers.Register }),
          _react2.default.createElement(_reactRouter.Route, { path: 'forgetPassword', component: _containers.ForgetPassword })
        ),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: 'contactus', component: _containers.ContactUs },
          _react2.default.createElement(_reactRouter.Route, { path: 'about', component: _containers.About }),
          _react2.default.createElement(_reactRouter.Route, { path: 'callus', component: _containers.CallUs }),
          _react2.default.createElement(_reactRouter.Route, { path: 'standarddisclaimer', component: _containers.StandardDisclaimer }),
          _react2.default.createElement(_reactRouter.Route, { path: 'assuredeclare', component: _containers.AssureDeclare }),
          _react2.default.createElement(_reactRouter.Route, { path: 'legalstatement', component: _containers.LegalStatement })
        ),
        _react2.default.createElement(_reactRouter.Route, { path: 'shopregisterprotocol', component: _containers.ShopRegisterProtocol }),
        _react2.default.createElement(_reactRouter.Route, { path: 'serviceshopregisterprotocol', component: _containers.ServiceShopRegisterProtocol }),
        _react2.default.createElement(_reactRouter.Route, { path: 'shopannouncement', component: _containers.ShopAnnouncement }),
        _react2.default.createElement(_reactRouter.Route, { path: 'encyclopedia', component: _containers.Encyclopedia }),
        _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopsmap', component: _containers.ExperienceShopsMap }),
        _react2.default.createElement(_reactRouter.Route, { path: 'maplikepage', component: _containers.MapLikePage }),
        _react2.default.createElement(_reactRouter.Route, { path: 'search', component: _containers.MainSearchPage }),
        _react2.default.createElement(_reactRouter.Route, { path: 'experienceshoplist', component: _containers.ExperienceShopList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'designerlist', component: _containers.DesignerList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'workstationlist', component: _containers.WorkStationNewList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'newmedium', component: _containers.NewMedium }),
        _react2.default.createElement(_reactRouter.Route, { path: 'servicesmarket', component: _containers.ServicesHomePage }),
        _react2.default.createElement(_reactRouter.Route, { path: 'workstationshoplist/:workstationId', component: _containers.WorkStationShopList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'beautifulservices', component: _containers.BeautifulServices }),
        _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopproductlist/:experienceShopId', component: _containers.ExperienceShopProductList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'shopproductList/:shopId', component: _containers.ShopProductList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'shopdesignerlist/:shopId', component: _containers.ShopDesignerList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'designerproductlist/:designerId', component: _containers.DesignerProductList }),
        _react2.default.createElement(_reactRouter.Route, { path: 'wslp', component: _containers.WSLP })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { onEnter: changeBackGroundColorToWhiteAndLogin },
        _react2.default.createElement(_reactRouter.Route, { path: 'newmediumcenter', component: _containers.NewMediumCenter }),
        _react2.default.createElement(_reactRouter.Route, { path: 'merchantauthentication', component: _containers.MerchantAuthentication }),
        _react2.default.createElement(_reactRouter.Route, { path: 'exhibitionHallBtn', component: _containers.ExhibitionHallBtn }),
        _react2.default.createElement(_reactRouter.Route, { path: 'publicpayment/:orderNumber/:activeId', component: _containers.PublicPayment }),
        _react2.default.createElement(_reactRouter.Route, { path: 'wechatpayment', component: _containers.WechatPayment }),
        _react2.default.createElement(_reactRouter.Route, { path: 'paymentsuccess/:activeId', component: _containers.AlipaySuccessPage }),
        _react2.default.createElement(_reactRouter.Route, { path: 'serviceorderbuy/:serviceProductId', component: _containers.ServiceOrderBuy }),
        _react2.default.createElement(_reactRouter.Route, { path: 'orderwriting/:orderNumber', component: _containers.OrderWriting }),
        _react2.default.createElement(_reactRouter.Route, { path: 'payment/:orderNumber/:activeId', component: _containers.PaymentPage }),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: 'personalcenter', component: _containers.PersonalCenter },
          _react2.default.createElement(
            _reactRouter.Route,
            { path: 'personalinfo', component: _containers.PersonalBasicInfo },
            _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.PersonalCenterDefault }),
            _react2.default.createElement(_reactRouter.Route, { path: 'becomepartner', component: _containers.PersonalCenterBecomePartner }),
            _react2.default.createElement(_reactRouter.Route, { path: 'changepassword', component: _containers.PersonalCenterChangePassWord }),
            _react2.default.createElement(_reactRouter.Route, { path: 'addressmanager', component: _containers.PersonalAddressManager }),
            _react2.default.createElement(_reactRouter.Route, { path: 'invoicemanager', component: _containers.PersonalInvoiceManager }),
            _react2.default.createElement(_reactRouter.Route, { path: 'authmanager', component: _containers.PersonalAuthManager }),
            _react2.default.createElement(_reactRouter.Route, { path: 'companyinfo', component: _containers.PersonalCenterCompanyInfo })
          ),
          _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopregister', component: _containers.ExperienceShopRegister }),
          _react2.default.createElement(
            _reactRouter.Route,
            { path: 'personalbuying', component: _containers.PersonalBuying },
            _react2.default.createElement(_reactRouter.Route, { path: 'productpreselection', component: _containers.ProductPreselection }),
            _react2.default.createElement(_reactRouter.Route, { path: 'fidelitysearch', component: _containers.PersonalBuyingFidelitySearch })
          ),
          _react2.default.createElement(
            _reactRouter.Route,
            { path: 'personalservices', component: _containers.PersonalServices },
            _react2.default.createElement(_reactRouter.Route, { path: 'artsalon', component: _containers.ArtSalon }),
            _react2.default.createElement(_reactRouter.Route, { path: 'crowdfundingmessage', component: _containers.CrowdfundingMessage }),
            _react2.default.createElement(_reactRouter.Route, { path: 'preferentialmessage', component: _containers.PreferentialMessage }),
            _react2.default.createElement(_reactRouter.Route, { path: 'encyclopedicknowledge', component: _containers.EncyclopedicKnowledge }),
            _react2.default.createElement(_reactRouter.Route, { path: 'attentionartwork', component: _containers.AttentionArtwork }),
            _react2.default.createElement(_reactRouter.Route, { path: 'attentiondesigner', component: _containers.AttentionDesigner }),
            _react2.default.createElement(_reactRouter.Route, { path: 'attentionshop', component: _containers.AttentionShop })
          ),
          _react2.default.createElement(
            _reactRouter.Route,
            { path: 'experienceshop', component: _containers.PersonalExperienceShop },
            _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopinfo', component: _containers.MyExperienceShopInfo }),
            _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopselling', component: _containers.ExperienceShopSelling }),
            _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopinfochange', component: _containers.ExperienceShopInfoChange }),
            _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopmembers', component: _containers.ExperienceShopMembers }),
            _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopmembersdetails/:memberId', component: _containers.ExperienceShopMembersDetails }),
            _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopproducts', component: _containers.ExperienceShopProducts }),
            _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopproductdetails/:productId', component: _containers.ExperienceShopProductDetails }),
            _react2.default.createElement(_reactRouter.Route, { path: 'experienceshoppromotion', component: _containers.ExperienceShopPromotion }),
            _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopcommission', component: _containers.ExperienceShopCommission })
          ),
          _react2.default.createElement(
            _reactRouter.Route,
            { path: 'mywallet', component: _containers.MyWallet },
            _react2.default.createElement(_reactRouter.Route, { path: 'mycommissions', component: _containers.MyCommissions })
          ),
          _react2.default.createElement(_reactRouter.Route, { path: 'myclients', component: _containers.MyClients }),
          _react2.default.createElement(_reactRouter.Route, { path: 'clientdetails/:clientId', component: _containers.ClientDetails })
        ),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: 'experienceshop', component: _containers.MyExperienceShop },
          _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopinfo', component: _containers.MyExperienceShopInfo }),
          _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopmembers', component: _containers.ExperienceShopMembers }),
          _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopmembersdetails', component: _containers.ExperienceShopMembersDetails }),
          _react2.default.createElement(_reactRouter.Route, { path: 'experienceshopproducts', component: _containers.ExperienceShopProducts })
        )
      ),
      _react2.default.createElement(_reactRouter.Route, { path: 'prompt', component: _containers.PromptPages }),
      _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
    )
  );
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes.js
 ** module id = 1565
 ** module chunks = 0
 **/